import Vue from 'vue'
import Router from 'vue-router'

import { store } from '../main.js'

import Login from './login'
import Home from './home'
import Public from './public'
import Profile from './profile'


Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: "active",
    hashbang: false,
    routes: [
        Login,
        Home,
        Public,
        Profile
    ],
    scrollBehavior() {
        document.getElementById('app').scrollIntoView();
    }
});

router.beforeEach((to, from, next) => {

    const authenticated = localStorage.getItem('token');
    let to_splited = to.path.toString().split('/')
    to_splited = to_splited.filter(part => part !== '')

    if (
        !authenticated &&
        (
            !(['/login'].includes(to.path.toString())) &&
            !(['public'].includes(to_splited[0]))
        )
    ) {
        next('/login');

        return true;
    }

    if (authenticated && to.path.toString() == '/login') {
        next('/');

        return true;
    }

    next();
});

router.afterEach((to, from) => {
    let _name = to.name;
    let _route = to.fullPath;

    if (_name === 'Home') {
        _name = '';
        _route = '';
    }

    store.commit("updateBreadCrumbs", { name: _name, route: _route })
});


export default router



// WEBPACK FOOTER //
// ./src/router/index.js